import React from 'react';
import classnames from 'classnames';
import { Buttons } from '../buttons';
import cssBase from '../../collect-sizes-popup.scss';
import { dialogText } from './greetings-dialog.constants';
export const GreetingsDialog = ({
  isLimitedEdition,
  onClose,
  onNext
}) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
  className: classnames(cssBase.header, {
    [cssBase.headerLE]: isLimitedEdition
  })
}, "Let\u2019s collect sizes from your recipients!"), /*#__PURE__*/React.createElement("p", {
  className: cssBase.text,
  "data-text": "Tutorial"
}, dialogText), /*#__PURE__*/React.createElement(Buttons, {
  isButtonResponsive: true,
  onNextButton: onNext,
  onBackButton: onClose,
  nextText: "Yes, Let's Create a Link!",
  backText: "No Thanks!"
}));